module.exports = __webpack_public_path__ + "media/images/stripe-87ba44a7ffc67b7e49aff4a0a053e483.svg";